export function secondsToDigitalText(seconds) {
    if (seconds) {
        const parts = secondsToParts(seconds);
        return `${parts.minutes}:${parts.seconds < 10 ? ('0' + Math.floor(parts.seconds).toString()) : Math.floor(parts.seconds)}`
    } 

    return '0:00';
}

export function secondsToVerboseText(seconds) {
    const parts = secondsToParts(seconds);

    const minuteString = `${parts.minutes} minute${parts.minutes === 1 ? '' : 's'}`;
    const secondString = `${parts.seconds} second${parts.seconds === 1 ? '' : 's'}`;

    return `${parts.minutes === 0 ? '' : minuteString} ${parts.seconds === 0 && parts.minutes !== 0 ? '' : secondString}`
}

export function secondsToParts(seconds) {
    return {
        minutes: Math.floor(seconds / 60),
        seconds: seconds % 60
    }
}

export function getMilliseconds() {
    return {
        fromSeconds: (value) => value * 1000,
        fromMinutes: (value) => (value * 60) * 1000
    }
}

export function getTimeZoneOffset() {
    let currentDate = new Date();
    let currentTimeZoneOffsetInHours = currentDate.getTimezoneOffset() / 60;
    return currentTimeZoneOffsetInHours;
};

export const formatDate = (dateString) => {
    if (!dateString) return "-";

    const d = new Date(dateString);
    
    if (!isNaN(d.getTime()) && !(typeof dateString === 'string' && dateString.includes('.') && dateString.includes(' '))) {
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');

        return `${month}.${day}.${year} ${hours}:${minutes}`;
    }

    if (typeof dateString === 'string' && dateString.includes('.') && dateString.includes(' ')) {
        try {
            const [datePart, timePart] = dateString.split(' ');
            const parts = datePart.split('.');
            
            if (parts.length === 3) {
                const [day, month, year] = parts;
                return `${month}.${day}.${year} ${timePart?.substring(0, 5) || ''}`;
            }
        } catch (e) {
            return dateString;
        }
    }

    return isNaN(d.getTime()) ? "Invalid Date" : dateString;
};

export const getRelativeTime = (dateInput) => {
    if (!dateInput) return '';

    let formattedInput = dateInput;
    if (typeof dateInput === 'string' && !dateInput.includes('Z') && !dateInput.includes('+')) {
        formattedInput = `${dateInput}Z`;
    }
    const date = new Date(formattedInput);
    if (isNaN(date.getTime())) return '';

    const now = new Date();
    const diffInSeconds = (date.getTime() - now.getTime()) / 1000;
    const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'always' });
    const absSeconds = Math.abs(diffInSeconds);

    if (absSeconds < 60) {
        return rtf.format(Math.round(diffInSeconds), 'second');
    } 
    else if (absSeconds < 3600) {
        return rtf.format(Math.round(diffInSeconds / 60), 'minute');
    } 
    else if (absSeconds < 86400) { // 24 hours
        return rtf.format(Math.round(diffInSeconds / 3600), 'hour');
    } 
    else if (absSeconds < 604800) { // 7 days
        return rtf.format(Math.round(diffInSeconds / 86400), 'day');
    } 
    else if (absSeconds < 2592000) { // 30 days
        return rtf.format(Math.round(diffInSeconds / 604800), 'week');
    }
    else {
        return rtf.format(Math.round(diffInSeconds / 2592000), 'month');
    }
};